module.exports = __webpack_public_path__ + "static/img/new0.01353865.png";